export default __webpack_public_path__ + "static/media/photo--sm--46.b8c6b0c2.jpg";